<template>
  <div class="footer-bottom">
    <div class="container">
      <div class="row text-center text-md-left">

        <div class="col-sm">
          Copyright © 2025 
          <a href="#">SmartWave Solutions Pvt.Ltd . All rights reserved.</a>
          <span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>

          <ul class="footer-links">
            <li><router-link to="/tutorial" active-class="active">TUTORIAL</router-link></li>
             
          </ul>
        </div>

        <div class="col-sm-auto ml-auto">
          <span class="d-none d-sm-inline">For Support&nbsp;&nbsp;&nbsp;</span>
          <i class="fas fa-phone"></i>&nbsp;&nbsp;<b>9633011603</b>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterBottom",
  methods: {
    goToTutorial() {
    // if (this.$route.name !== "TutorialPage") {
      this.$router.push({ name: "TutorialPage" });
    }
  },
};
</script>

<style scoped>
.footer-bottom {
  background-color: #206A98;
  color: white;
  padding: 15px 0;
  font-size: 14px;
}

.footer-bottom a {
  color: #fff;
  text-decoration: none;
}

.footer-bottom a:hover {
  text-decoration: underline;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.col-sm {
  flex: 1;
  min-width: 250px;
  margin-bottom: 10px;
}

.col-sm-auto {
  margin-left: auto;
  min-width: 200px;
}

.footer-links {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: inline-block;
}

.footer-links li {
  display: inline;
  margin-right: 15px;
}

.d-none {
  display: none;
}

.d-sm-inline {
  display: inline;
}

/* ✅ Mobile Responsive Fixes */
@media (max-width: 768px) {
  .row {
    flex-direction: column;
    text-align: center;
  }

  .col-sm-auto {
    margin-left: 0;
  }

  .footer-links li {
    display: block;
    margin: 8px 0;
  }

  .footer-links {
    padding-top: 10px;
  }
}

@media (max-width: 480px) {
  .footer-bottom {
    font-size: 12px;
    padding: 12px 0;
  }

  .footer-links li {
    margin-right: 0;
  }
}
</style>


